import { Box } from '@mantine/core'
import {
  IconBuildingFactory2,
  IconReceiptTax,
  IconTruck,
  IconWood,
} from '@tabler/icons-react'
import { useEffect, useState } from 'react'

import classes from '~/widgets/TariffCalculator/components/TariffCalculatorLoadingAnimation.module.css'

const ANIMATION_INTERVAL = 700

export function TariffCalculatorLoadingAnimation() {
  const [activeIcon, setActiveIcon] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIcon((current) => (current + 1) % 4)
    }, ANIMATION_INTERVAL)

    return () => clearInterval(interval)
  }, [])

  return (
    <Box>
      <div className={classes.wrapper}>
        <Box className={classes.icon} data-active={activeIcon === 0}>
          <IconWood size={32} />
        </Box>
        <div className={classes.line} />
        <Box className={classes.icon} data-active={activeIcon === 1}>
          <IconBuildingFactory2 size={32} />
        </Box>
        <div className={classes.line} />
        <Box className={classes.icon} data-active={activeIcon === 2}>
          <IconTruck size={32} />
        </Box>
        <div className={classes.line} />
        <Box className={classes.icon} data-active={activeIcon === 3}>
          <IconReceiptTax size={32} />
        </Box>
      </div>
    </Box>
  )
}
